<div class="pendar-calender" [ngClass]="thisMonth.monthColor">
  <ng-container *ngIf="level == 0">
    <div class="top-header p-2">
      <div class="button-style">
        <button
          type="button"
          class="next-month-button p-1"
          (click)="previousMonth()"
        >
          <i
            class="fa-solid"
            [ngClass]="isRtl == true ? 'fa-chevron-right' : 'fa-chevron-left'"
          ></i>
        </button>
      </div>
      <div class="button-style">
        <button type="button" class="button-month" (click)="level = 2">
          {{ thisMonth.monthName }}
        </button>
      </div>
      <div class="button-style">
        <button type="button" class="button-year" (click)="level = 1">
          {{ thisMonth.year }}
        </button>
      </div>
      <div class="button-style">
        <button type="button" class="previous-month p-1" (click)="nextMonth()">
          <i
            class="fa-solid fa-chevron-left"
            [ngClass]="isRtl == true ? 'fa-chevron-left' : 'fa-chevron-right'"
          ></i>
        </button>
      </div>
    </div>
    <div class="col-12 calender-box-header">
      <div class="calender-header-item" *ngFor="let item of weekName">
        <p>{{ item.summaryName }}</p>
      </div>
    </div>
    <div class="col-12 calender-box">
      <div class="calender-item pt-1 ps-1" *ngFor="let day of thisMonth.days">
        <ng-container *ngIf="day.dayOfMonth != 0; else noDate">
          <button
            type="button"
            class="button-design"
            [class.active-day]="
              (todayJalali.year == selectedYear &&
              todayJalali.month==selectedMonth&&
              day.dayOfMonth == todayJalali.day)||
              (todayGregorian.year == selectedYear &&
              todayGregorian.month==selectedMonth&&
              day.dayOfMonth == todayGregorian.day)
            "
            (click)="selectDay(day)"
          >
            {{ day.dayOfMonth }}
          </button>
        </ng-container>
        <ng-template #noDate>
          <button type="button" class="button-no-select-design">--</button>
        </ng-template>
      </div>
    </div>
    <hr class="m-0" />
    <div class="footer-button p-2 pt-1">
      <button type="button" class="button-design" (click)="GotoDay()">
        {{ "Datapicker.Now" | translate }}
      </button>
      <button type="button" class="button-design" *ngIf="calenderIsJalali" (click)="ToGregorian()">
        {{ "Datapicker.Gregorian" | translate }}
      </button>
      <button type="button" class="button-design" *ngIf="!calenderIsJalali" (click)="ToJalali()">
        {{ "Datapicker.Jalali" | translate }}
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="level == 1">
    <div class="row px-3 year-box">
      <div class="top-year-header p-0 py-1">
        <div class="button-style">
          <button
            type="button"
            class="next-month-button p-0"
            (click)="level = 0"
          >
            <i class="fas fa-reply"></i>
          </button>
        </div>
      </div>
      <hr class="my-1" />

      <div class="col-1 p-0 calender-box mb-2">
        <button
          type="button"
          class="next-month-button p-1"
          (click)="previousYearPage()"
        >
          <i
            class="fa-solid"
            [ngClass]="isRtl == true ? 'fa-chevron-right' : 'fa-chevron-left'"
          ></i>
        </button>
      </div>

      <div class="col-10 p-0 calender-box mb-2">
        <div
          class="calender-item calender-year-item p-1"
          *ngFor="let year of thisYears"
        >
          <button
            type="button"
            class="button-design"
            (click)="selectYear(year.yearNumber)"
            [ngClass]="{ 'active-year': year.yearNumber == selectedYear }"
          >
            {{ year.yearNumber }}
          </button>
        </div>
      </div>
      <div class="col-1 p-0 calender-box mb-2">
        <button
          type="button"
          class="previous-month p-1"
          (click)="nextYearPage()"
        >
          <i
            class="fa-solid fa-chevron-left"
            [ngClass]="isRtl == true ? 'fa-chevron-left' : 'fa-chevron-right'"
          ></i>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="level == 2">
    <div class="row px-3 year-box">
      <div class="top-year-header p-0 py-1">
        <div class="button-style">
          <button
            type="button"
            class="next-month-button p-0"
            (click)="level = 0"
          >
            <i class="fas fa-reply"></i>
          </button>
        </div>
      </div>
      <hr class="my-1" />

      <div class="col-12 p-0 calender-box mb-2">
        <div
          class="calender-item calender-month-item p-1"
          *ngFor="let month of months"
        >
          <button
            type="button"
            class="button-design"
            [class.active-month]="month.monthNumber == selectedMonth"
            [ngClass]="month.monthCssClass"
            (click)="selectMonth(month.monthNumber)"
          >
            {{ month.monthName }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
